import {
  LAST_UPDATED,
  SHIFT,
  STATUS,
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_CANCEL_SUBMITTED,
  STATUS_EXPIRED_ADM,
  STATUS_REFUSED,
  STATUS_RETRACTED,
  STATUS_SUBMITTED,
  TIME_OFF_TYPE,
} from "./constants";

export const _TOR_StatusSortedOrderList = [
  STATUS_SUBMITTED,
  STATUS_CANCEL_SUBMITTED,
  STATUS_EXPIRED_ADM,
  STATUS_APPROVED,
  STATUS_CANCELED_ADM,
  STATUS_CANCELED_EE,
  STATUS_REFUSED,
  STATUS_RETRACTED,
];

function getCellValues(_TOR_1, _TOR_2) {
  let _TOR1 = _TOR_1.api.getCellValue(_TOR_1.id, _TOR_1.field);
  let _TOR2 = _TOR_2.api.getCellValue(_TOR_2.id, _TOR_2.field);
  return { _TOR1, _TOR2 };
}

export function getSortedTimeOffRequestsByLastUpdated(_TORCreatedAt1, _TORCreatedAt2, TOR_1, TOR_2) {
  if (!TOR_1) {
    _TORCreatedAt1 = _TORCreatedAt1.lastUpdatedDate;
    _TORCreatedAt2 = _TORCreatedAt2.lastUpdatedDate;
  }
  if (
    _TORCreatedAt1.year === _TORCreatedAt2.year &&
    _TORCreatedAt1.month === _TORCreatedAt2.month &&
    _TORCreatedAt1.day === _TORCreatedAt2.day &&
    _TORCreatedAt1.hour === _TORCreatedAt2.hour &&
    _TORCreatedAt1.minute === _TORCreatedAt2.minute
  ) {
    return 0;
  }
  return _TORCreatedAt1.toMillis() < _TORCreatedAt2.toMillis() ? -1 : 1;
}

export function getSortedTimeOffRequestByTimeOffType(_TOR_Type1, _TOR_Type2, _TOR_1, _TOR_2) {
  const { _TOR1, _TOR2 } = getCellValues(_TOR_1, _TOR_2);
  if (_TOR1 === _TOR2) {
    return 0;
  }
  return _TOR1 > _TOR2 ? 1 : -1;
}

export function getSortedTimeOffRequestByStatus(_TOR_Type1, _TOR_Type2, _TOR_1, _TOR_2) {
  const { _TOR1, _TOR2 } = getCellValues(_TOR_1, _TOR_2);
  if (_TOR1 === _TOR2) {
    return 0;
  }
  return _TOR_StatusSortedOrderList.indexOf(_TOR1) > _TOR_StatusSortedOrderList.indexOf(_TOR2) ? 1 : -1;
}

export function getSortedTimeOffRequestsByShift(_TORCreatedAt1, _TORCreatedAt2, TOR_1, TOR_2) {
  let tor1Row = TOR_1.api.getRow(TOR_1.id);
  let tor2Row = TOR_2.api.getRow(TOR_2.id);
  let tor1Shift = tor1Row.shiftStart;
  let tor2Shift = tor2Row.shiftStart;
  return tor1Shift.toMillis() > tor2Shift.toMillis() ? 1 : -1;
}

export function getTORStatusCustomComparator(statusFromMobile1, statusFromMobile2, timeOffRequest1, timeOffRequest2) {
  let timeOffRequest1Row;
  let timeOffRequest2Row;
  let timeOffRequest1Status;
  let timeOffRequest2Status;
  if (isCallFromMobile(timeOffRequest1)) {
    timeOffRequest1Row = timeOffRequest1;
    timeOffRequest2Row = timeOffRequest2;
    timeOffRequest1Status = statusFromMobile1;
    timeOffRequest2Status = statusFromMobile2;
  } else {
    timeOffRequest1Row = timeOffRequest1.api.getRow(timeOffRequest1.id);
    timeOffRequest2Row = timeOffRequest2.api.getRow(timeOffRequest2.id);
    timeOffRequest1Status = timeOffRequest1Row[timeOffRequest1.field];
    timeOffRequest2Status = timeOffRequest2Row[timeOffRequest2.field];
  }
  if (timeOffRequest1Status === timeOffRequest2Status) {
    return 0;
  }

  return _TOR_StatusSortedOrderList.indexOf(timeOffRequest1Status) >
    _TOR_StatusSortedOrderList.indexOf(timeOffRequest2Status)
    ? 1
    : -1;
}

function isCallFromMobile(timeOffRequest) {
  if (timeOffRequest.api) {
    return false;
  }
  return true;
}

export function sortEmployeeTimeOffRequestsByFilter(sortValue, sortedTimeOffRequests) {
  switch (sortValue) {
    case SHIFT:
      sortedTimeOffRequests = sortedTimeOffRequests.sort((a, b) => {
        return b.shiftStart.toMillis() > a.shiftStart.toMillis() ? -1 : 1;
      });
      break;
    case STATUS:
      sortedTimeOffRequests = sortedTimeOffRequests.sort((a, b) => {
        return getTORStatusCustomComparator(a.visibleStatus, b.visibleStatus, a, b);
      });
      break;
    case LAST_UPDATED:
      sortedTimeOffRequests = sortedTimeOffRequests.sort((a, b) => {
        return b.lastUpdatedDate.toMillis() - a.lastUpdatedDate.toMillis();
      });
      break;
    case TIME_OFF_TYPE:
      sortedTimeOffRequests = sortedTimeOffRequests.sort((a, b) => {
        return b.timeOffRequestType > a.timeOffRequestType ? -1 : 1;
      });
      break;
    default:
      break;
  }
  return sortedTimeOffRequests;
}

export function getTimeOffEmployeeLastNameCustomComparator(test1, test2, TOR1, TOR2) {
  let TOR1Row = TOR1.api.getRow(TOR1.id);
  let TOR2Row = TOR2.api.getRow(TOR2.id);
  if (TOR1Row.empLastName === TOR2Row.empLastName) {
    if (TOR1Row.empFirstName === TOR2Row.empFirstName) {
      return 0;
    }
    return TOR1Row.empFirstName > TOR2Row.empFirstName ? 1 : -1;
  }
  return TOR1Row.empLastName > TOR2Row.empLastName ? 1 : -1;
}